import { IUserInfo } from "../../../../../models/User";
import { IResponseState } from "../../../ResponseModal/module/constants";

export interface IOTPModalProps {
  show: boolean;
  onClose: () => void;
  onContinueLinkClick?: () => void;
  onConfirm: () => void;
  maximumTime?: number;
  requireUserCode?: boolean;
  securityAllowed?: boolean;
  userProp: string;
  otpProp: string;
  modalOtpState: IResponseState;
  setUserProp: any; //TODO??
  setOtpProp: any; //TODO??
  sendOtp: any; //TODO??
  isLoginPage: boolean;
  currentLoggedUser: IUserInfo;
  resetModalOtpState: () => {};
  retrysLeft: number;
  onConfirmOperation: (body: any) => void;
}

export enum IGrantType {
  OTP = "otp",
  UIGP_OTP = "uigp_otp",
  SECURITYQUEST = "security-questions",
}
